export const DEFAULT_CHECKOUT_ERROR = 'h24_something_went_wrong';

export const SUCCCESS_STEP_PATH = '/checkout/success';

export const CONFIRMATION_PATH = '/checkout/new?page=confirmation';
export const DIGITAL_CONFIRMATION_PATH = '/giftcard/checkout/new?page=confirmation';
export const PAYMENT_PATH = '/checkout/new?page=payment';
export const ADDRESS_PATH = '/checkout/new?page=address';
export const DIGITAL_ADDRESS_PATH = '/giftcard/checkout/new?page=address';

export const PAYMENT_NOT_SET_IN_CONFIRM_STEP_ERROR = 'PaymentNotSetInConfirmPage';

export const REGISTRATION_URL = '/registration';
export const CHECKOUT_SIGNUP_URL = '/checkout/signup';

export const KNOWN_CHECKOUT_ERRORS = [
  'h24_checkout-error_AddressZipIsBlacklisted',
  'h24_checkout-error_DeleteBillingAddressNotAllowed',
  'h24_checkout-error_InvalidAddressId',
  'h24_checkout-error_TelNumberMissing',
  'h24_checkout-error_AddressNotSet',
  'h24_checkout-error_AddressValidationError',
  'h24_checkout-error_AddressDuplicate',
  'h24_checkout-error_EmptyCart',
  'h24_checkout-error_CartChanged',
  'h24_checkout-error_CustomerNotFound',
  'h24_checkout-error_CheckoutNotFound',
  'h24_checkout-error_InternalError',
  'h24_checkout-error_ExternalServiceError',
  'h24_checkout-error_BadRequest',
  'h24_checkout-error_VoucherConsumptionFailed',
  'h24_checkout-error_NoDeviceInfo',
  'h24_checkout-error_WrongLocale',
  'h24_checkout-error_PaymentNotSet',
  'h24_checkout-error_PaypalOrderAmountExceeded',
  'h24_checkout-error_ValidationError',
  'h24_checkout-error_UNKNOWN_ERROR',
  'h24_checkout-error_CONFLICT',
  'h24_checkout-error_NOT_FOUND',
  'h24_checkout-error_VALIDATION_FAILED',
  'h24_checkout-error_Forbidden',
  'h24_checkout-error_ExpressOrderDataChanged',
  'h24_checkout-error_CREDITCARD_CREDIT_CARD_CVC_INVALID',
  'h24_checkout-error_CREDITCARD_VALIDATION_FAILED',
  'h24_checkout-error_CREDITCARD_PSEUDO_CARD_PAN_UNKNOWN',
  'h24_checkout-error_CREDITCARD_CREDIT_CARD_NUMBER_INVALID',
  'h24_checkout-error_CREDITCARD_CREDIT_CARD_TYPE_INVALID',
  'h24_checkout-error_CREDITCARD_CREDIT_CARD_EXPIRY_DATE_INVALID',
  'h24_checkout-error_CREDITCARD_CREDIT_CARD_IS_CANCELED',
  'h24_checkout-error_UNKNOWN_CARD',
  'h24_checkout-error_PAYMENT_DENIED',
  'h24_checkout-error_PAYMENT_DENIED_CREDIT_CARD_REJECTED',
  'h24_checkout-error_PAYMENT_DENIED_VELOCITY_IP_DENIED',
  'h24_checkout-error_PAYMENT_DENIED_VELOCITY_CREDIT_CARD_DENIED',
  'h24_checkout-error_PAYMENT_DENIED_VELOCITY_EMAIL_DENIED',
  'h24_checkout-error_PAYMENT_DENIED_FRAUD_SUSPECTED',
  'h24_checkout-error_BANKACCOUNT_ACCOUNT_NUMBER_INVALID',
  'h24_checkout-error_BANKACCOUNT_BANK_CODE_INVALID',
  'h24_checkout-error_BANKACCOUNT_BANK_COUNTRY_INVALID',
  'h24_checkout-error_PAYMENT_CONFIGURATION_ERROR',
  'h24_checkout-error_PAYMENT_ERROR_DUPLICATE_ORDER_NUMBER',
  'h24_checkout-error_PAYMENT_ERROR_PORTAL_CONFIGURATION',
  'h24_checkout-error_PAYMENT_ERROR_MAINTENANCE_IN_PROGRESS',
  'h24_checkout-error_PAYMENT_ERROR_INVALID_CURRENCY',
  'h24_checkout-error_PAYMENT_ERROR_AMOUNT_INVALID',
  'h24_checkout-error_PAYMENT_ERROR_CUSTOMER_LASTNAME_INVALID',
  'h24_checkout-error_PAYMENT_ERROR_CUSTOMER_COMPANY_INVALID',
  'h24_checkout-error_PAYMENT_ERROR_SYSTEM_TEMPORARILY_UNAVAILABLE',
  'h24_checkout-error_UNKNOWN_PAYMENT_METHOD',
  'h24_checkout-error_PAY_ONE_CONFIGURATION_IS_MISSING',
  'h24_checkout-error_PSP_CONFIGURATION_IS_MISSING',
  'h24_checkout-error_PSP_TRANSACTION_FAILED',
  'h24_checkout-error_PSP_INVALID_RESPONSE',
  'h24_checkout-error_CURL_INITIALIZATION_ERROR',
  'h24_checkout-error_CURL_REQUEST_ERROR',

  `h24_checkout-error_${PAYMENT_NOT_SET_IN_CONFIRM_STEP_ERROR}`,
];
